import { useEffect, useRef, useState, createContext, useContext } from "react";

import './style.css';

export const MarkerContext = createContext(null);

export function MarkerContextProvider({ children}){

    const [markers, setMarkers] = useState({ 
        axial: { position: 50, canvasWidth: 0, canvasHeight: 0 }, 
        sagittal: { position: 50, canvasWidth: 0, canvasHeight: 0 }, 
        coronal: { position: 0, canvasWidth: 0, canvasHeight: 0 } 
    });

    function updateMarkers(updates){
        //console.log(marker, 'update', updates)
        setMarkers(prev => {
            const updated = {...prev};
            for (const mode in updates) {
                if (updates[mode] && typeof updates[mode] === 'object') {
                    updated[mode] = {...prev[mode], ...updates[mode]};
                } else {
                    updated[mode] = updates[mode];
                }
            }
            return updated;
        });
    }

    return(
        <MarkerContext.Provider value={{ markers, updateMarkers }}>
            { children }
        </MarkerContext.Provider>
    )
}

export default function SliceMarker({ mode }) {

    const canvasRef = useRef(null);
    const markerContext = useContext(MarkerContext);
    const markers = markerContext.markers;
    const marker = markers[mode];
    

    // Draws a horizontal marker line on the overlay canvas
    function drawHorizontalLine(lineY, color = 'red') {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');

        ctx.save();
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(0, lineY + 0.5); // +0.5 for crisp 1px line
        ctx.lineTo(marker.canvasWidth, lineY + 0.5);
        ctx.stroke();
        ctx.restore();

        //console.log(mode, lineY);
    }

    // Draws a vertical marker line on the overlay canvas
    function drawVerticalLine(lineX, color = 'blue') {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');

        ctx.save();
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(lineX + 0.5, 0); // +0.5 for crisp 1px line
        ctx.lineTo(lineX + 0.5, marker.canvasHeight);
        ctx.stroke();
        ctx.restore();

    }

    // Draws crosshair markers for slice navigation
    function drawSliceMarkers() {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        canvas.height = marker.canvasHeight;
        canvas.width = marker.canvasWidth;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw markers based on mode and slice indices
        if (mode === "axial") {
            drawHorizontalLine(markers.coronal.position, 'green');
            drawVerticalLine(markers.sagittal.position, 'blue');
        } else if (mode === "sagittal") {
            drawHorizontalLine(markers.axial.position, 'red');
            drawVerticalLine(markers.coronal.position, 'green');
        } else if (mode === "coronal") {
            drawHorizontalLine(markers.axial.position, 'red');
            drawVerticalLine(markers.sagittal.position, 'blue');
        }
    }

    useEffect(() => {
        drawSliceMarkers();
    }, [markers])

    return (
        <div>
            <canvas ref={canvasRef} className="markers" />
        </div>
    )
}